export default (apiMethods, endpoints) => ({
    getMessages: () => {
        return apiMethods.get(endpoints.GET_MESSAGES_ENDPOINT);
    },
    getReports: () => {
        return apiMethods.get(endpoints.GET_REPORTS_ENDPOINT);
    },
    getSuperAdminReports: () => {
        return apiMethods.get(endpoints.GET_SUPERADMIN_REPORTS_ENDPOINT);
    },
    addMessage: (fromId, toId, identifier, message) => {

        let identifierData = {}

        if (identifier.type === 'product') {
            identifierData = {
                productId: identifier.id
            }
        } else if (identifier.type === 'notification') {
            identifierData = {
                notificationId: identifier.id
            }
        }

        const data = {
            fromId,
            toId,
            message: message,
            ...identifierData
        }

        return apiMethods.post(endpoints.ADD_MESSAGE_ENDPOINT, data);
    },
    readMessages: (messageIds) => {
        return apiMethods.post(endpoints.READ_MESSAGES_ENDPOINT, {ids: messageIds})
    },
    deleteMessages: (messages) => {
        return apiMethods.post(endpoints.DELETE_MESSAGES_ENDPOINT, {
            ids: messages
        })
    }
})



// WEBPACK FOOTER //
// ./src/lib/api-message.js